import TranslateApi from "src/utils/TranslateHelper";
import { TranslateFunction } from "react-localize-redux";

export interface Language {
    id: number;
    name: string;
    code: string;
    url: string;
    isAvailable: boolean;
    isActive: boolean;
}

export default class Languages {
    public static Default: Language = { id: 0, name: "None", code: "", isAvailable: false, isActive: false, url: "" };
    public static English: Language = { id: 1, name: "English", code: "en-us", isAvailable: true, isActive: false, url: require("src/assets/qci/lingual/en-US.json") };
    public static Spanish: Language = { id: 2, name: "Español", code: "es-us", isAvailable: true, isActive: false, url: require("src/assets/qci/lingual/es-US.json") };
    public static AustralianEnglish: Language = { id: 3, name: "Australian English", code: "en-au", isAvailable: true, isActive: false, url: require("src/assets/qci/lingual/en-AU.json") };

    public static All: Language[] = [
        Languages.English,
        Languages.Spanish,
        Languages.AustralianEnglish,
    ];

    public static SetActiveLanguage(lang: Language, translate: TranslateFunction) {
        let languageCode = (lang.code || "").toLowerCase();
        // Set all isActive to false first
        this.All.forEach(x => x.isActive = false);
        // Get the one we want and activate it
        let foundLang = this.All.find(x => x.code === languageCode);
        foundLang.isActive = true;

        // Update translate function
        TranslateApi.translate = (key) => translate(key).toString();
        TranslateApi.currentLanguage = foundLang;
    }

    public static GetActiveLanguage() {
        return this.All.find(x => !!x.isActive);
    }

    public static FindById(id: number) {
        return this.All.find(x => x.id === id) || this.Default;
    }

    public static FindByCode(code: string) {
        return this.All.find(x => x.code.toLowerCase() === code.toLowerCase()) || this.Default;
    }
}



// WEBPACK FOOTER //
// ./src/constants/Languages.ts